import * as music from '@cuperman/music-theory';

import { Note } from './notes';
import { ChordType } from './chord_types';
import { Scale } from './scales';

export class Chord {
  public readonly rootNote: Note;
  public readonly chordType: ChordType;

  constructor(rootNote: Note, chordType: ChordType) {
    this.rootNote = rootNote;
    this.chordType = chordType;
  }

  notes(): Note[] {
    return this.chordType.notesInChord(this.rootNote);
  }

  name(): string {
    return [this.rootNote.name, this.chordType.name].join(' ');
  }

  inScale(scale: Scale): boolean {
    return music.chordInMode(
      this.notes().map((note) => note.value),
      scale.notes().map((note) => note.value)
    );
  }
}
